import dayjs from "dayjs";

export const getYearFraction = (date: string, year: number): number => {
  const yearStart = dayjs(`${year}-01-01`);
  const yearEnd = dayjs(`${year + 1}-01-01`);
  const fraction = dayjs(date).diff(yearStart) / yearEnd.diff(yearStart);

  return Math.min(1, Math.max(0, fraction));
};
